import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MINIMUM_TOP_UP } from "../../@core/interfaces/receptionist/payment";
import { PaymentService } from "../../@core/backend/receptionist/services/payment-service";
import { Observable, of } from "rxjs";

@Component({
  selector: "r247-top-up-input",
  templateUrl: "./top-up-input.component.html",
  changeDetection: ChangeDetectionStrategy.Default,
})
export class R247TopUpInputComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private paymentService: PaymentService
  ) {}

  @Input() minimumTopUp = MINIMUM_TOP_UP;
  @Input() topUpForm: FormGroup;
  @Output() amountChanged = new EventEmitter();

  topUpInputForm: FormGroup;

  netAndVat$!: Observable<{ netAmount: number; vatAmount: number }>;

  get isCustomAmount() {
    return this.topUpInputForm.get("amount").value === "custom";
  }

  get customAmount() {
    return this.topUpInputForm.get("customAmount");
  }

  ngOnInit(): void {
    this.netAndVat$ = this.paymentService.calculateNetAndVat(this.minimumTopUp);

    this.topUpInputForm = this.fb.group({
      amount: [this.minimumTopUp, [Validators.required]],
      customAmount: ["", Validators.min(this.minimumTopUp)],
    });
  }

  broadcastNewAmount() {
    let selectedAmount = this.topUpInputForm.get("amount").value;

    let amount = "";

    if (selectedAmount === "custom") {
      amount = this.topUpInputForm.get("customAmount").value;

      this.netAndVat$ =
        amount === ""
          ? of({
              netAmount: 0,
              vatAmount: 0,
            })
          : this.paymentService.calculateNetAndVat(parseFloat(amount));
    } else {
      amount = selectedAmount;
      this.netAndVat$ = this.paymentService.calculateNetAndVat(
        parseFloat(amount)
      );
    }

    this.amountChanged.emit(amount);
  }
}
